import React, { FC, PropsWithChildren, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import "./index.scss";

export interface AnimatedProps extends PropsWithChildren<{}> {
  in: boolean;
  appear?: boolean;
  timeout?: number;
  name?: string;
  onExited?: () => void;
  unmountOnExit?: boolean;
}

const Animated: FC<AnimatedProps> = props => {
  const {
    children,
    timeout = 300,
    in: inProp,
    name,
    unmountOnExit = true,
    ...rest
  } = props;

  const nodeRef = useRef(null);

  return (
    <CSSTransition
      nodeRef={nodeRef}
      unmountOnExit={unmountOnExit}
      classNames={name}
      in={inProp}
      timeout={timeout}
      {...rest}
    >
      {children}
    </CSSTransition>
  );
};

export default Animated;
